export default {
  CONTACT_SELLER_SUCCESS: 'CONTACT_SELLER_SUCCESS',
  CONTACT_QUESTION_SUCCESS: 'CONTACT_QUESTION_SUCCESS',
}
